// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsAdditional = {
  benefits_section_additional: {
    number_with_pay_period_range_label: '起价',
    provider_link: '查找医疗服务提供者',
    in_network: '网络内',
    cost_varies_label: '费用不等',
    enrollee_select_disclaimer: {
      contentful_name: 'Enrollee Select Disclaimer',
      header:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '对于某些福利,您可以更改承保对象以查看适用的费率。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      color: 'purple',
      url_button_text:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    coverage_details_header: '保障详情',
    network_name: '网络名称',
    coverage_disclaimer_available_to_spouses: '{plan}保险不适用于子女或伴侣。您可以为配偶投保。',
    coverage_disclaimer_available_to_partners_only: '{plan}保险不适用于配偶或子女。您可以为伴侣投保。',
    non_selectable_plans_label: '了解更多关于您雇主提供的此项服务的信息:',
    coverage_disclaimer_available_to_children:
      '{plan}保险不适用于配偶。您可以为伴侣和{maxAge}岁以下的子女投保。',
    life_ltc_benefit: {
      contentful_name: '[default] Life Ltc Benefit',
      card_title: '人寿+长期护理保险',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '终身寿险在受保家庭成员身故时提供赔付。此类计划还包括长期护理保障。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '人寿和长期护理保险是一种混合型计划,让您既能拥有终身人寿保险,又能在需要时获得长期护理的额外保障。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '这包括在您家中或其他地方(如疗养院、辅助生活设施或成人日托中心)的护理费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '只要您保留该计划,无论您的年龄、健康状况或经济形势如何变化,您的月保费都不会增加。当您去世时,您的亲人将获得赔付。或者,如果您改变主意,可以取消该计划并保留其现金价值。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '对于大多数保单,当您无法独立完成六项日常生活活动(ADL)中的至少两项时,您将有资格开始对您的计划提出理赔。官方的日常生活活动清单包括:',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '洗澡',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '穿衣',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '进食',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '处理大小便失禁',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '上下厕所',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '上下床或椅子',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '如果您患有痴呆症或其他认知障碍,您也可能符合资格。请务必查看您的计划文件以了解详情。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '**注意:**根据您的居住和工作地点,您还可能享有州政府资助的长期护理计划。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      benefit_page_title: '人寿+长期护理保险',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    network_info_header: '网络信息',
    best_match_badge_label: '非常合身',
    covered_conditions_table_header: '承保条件',
    contentful_name: '[DEFAULT] Benefits Section - Additional',
    page_header: {
      text: '选择更多福利',
      subtext: '您还有以下额外福利可供选择。',
    },
    fbs_plan_buy_up_info_bar: {
      contentful_name: '[Benefit Details] Fbs Plan Buy Up Info Bar',
      header:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '您可以选择购买以下额外保障,这些保障提供的福利超出此自动注册计划的范围。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      color: 'blue',
      url_button_text:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    coverage_disclaimer_available_to_all: '一般来说,孩子可能会被承保至{maxAge}岁。',
    cancer_benefit: {
      contentful_name: '[dafault] Cancer Benefit ',
      icon_link:
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/critical-illness.svg',
      card_title: '癌症保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '癌症保险在您被诊断患有癌症时提供经济保障。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '预计超过三分之一的美国人一生中会患癌症。虽然这个统计数据确实不太乐观,但得益于现代医学的进步,越来越多的人也在战胜癌症后幸存下来。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '但抗击癌症的费用高昂。医疗保险可以覆盖大部分治疗费用,但您几乎肯定会达到当年的自付费用上限。更不用说前往就诊的交通费用、因请假而损失的收入,以及所有日常开支。这就是癌症保险可以提供帮助的地方。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '如果您被诊断出患有承保范围内的癌症,这类保单会向您寄送一张支票,您可以用它来帮助支付医疗费用,或用于任何您想要的开支。根据您所需的治疗类型,您还可能获得额外的赔付,甚至在未确诊的情况下接受某些预防性护理也可能获得赔付。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '重要提示:癌症保险不会承保您在投保前已被诊断出的任何疾病。因此,如果您正在考虑购买此类保险,越早越好。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '这些保单也不会为您在治疗过程中出现的任何癌症相关疾病支付赔付金,并且如果您之前患过的癌症复发,可能会有相关限制。详情请查看您的保单文件。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      benefit_page_title: '癌症保险',
      custom_module_benefit: '由您的雇主提供的额外补充福利',
    },
    accessibility: {
      expand_benefit_details: '显示更多{x}详情',
      collapse_benefit_details: '隐藏{x}详情',
    },
    text_note: {
      contentful_name: '[DEFAULT] Text Note',
      short_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      long_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '您提供的内容为空,没有需要翻译的文本。请提供需要从英语(美国)翻译成简体中文(中国)的具体内容。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      button_text: '阅读更多',
    },
    provider_directory: '医疗服务提供者名录',
    coverage_options_auto_enrolled_label: '选择您要为谁添加额外保障。',
    id_theft_benefit: {
      contentful_name: 'Id Theft Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/legal_services.svg',
      card_title: '身份盗窃',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '身份盗窃保护福利可保护您免受身份盗窃侵害,并在您成为身份盗窃受害者时帮助您恢复。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '身份盗窃保护福利通过监控互联网上与您的信用和其他账户相关的可疑活动,并在发现可疑活动时向您发送警报,帮助阻止犯罪分子。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '如果确实发生身份盗窃,这些福利还可以帮助您减轻损害,为您提供专业顾问的支持,帮助您度过逆转身份盗窃损害这一耗时且充满压力的过程。某些福利还包括保险,帮助您承担与身份盗窃相关的费用,例如工资损失、法律费用或被盗资金的直接赔偿。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '您可享受的具体福利可能有所不同,因此请务必仔细查看您的计划详情。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319614',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    covered_conditions_table_subheader: '以下是触发本计划赔付的条件。',
    fbs_plan_auto_enrolled_info_bar: {
      contentful_name: '[Benefit Details] Fbs Plan Auto Enrolled Info Bar',
      header:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '您的雇主免费为您提供此计划!',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      color: 'blue',
      url_button_text:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    coverage_options_label: '首先,选择您要承保的人员。',
    other_benefit: {
      contentful_name: 'Other Benefit',
      card_title: '其他福利',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '您的雇主提供的额外补充福利',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit: '由您的雇主提供的额外补充福利',
    },
    coverage_disclaimer_available_to_none: '并非所有家庭成员都符合此福利的资格。',
    coverage_disclaimer_available_to_children_only:
      '{plan}保险不适用于配偶或伴侣。您可以为子女投保至{maxAge}岁。',
    coverage_disclaimer_available_to_partners: '{plan}保险不适用于儿童。您可以为配偶或伴侣投保。',
    recommended_badge_label: '合适',
    tooltips: {
      best_match_badge:
        'Of the additional benefits available to you, this looks like your best fit. Click "Choose" or "Learn More" to see why.',
      recommended_badge:
        'This type of benefit looks like a good option for you. Click "Choose" or "Learn More" to see why.',
      max_annual_benefit: {
        text: 'This is the maximum amount that your plan will cover for dental services in a year.',
        title: 'Maximum Annual Benefit',
      },
    },
    coverage_disclaimer_spouses_and_children:
      '{plan}保险不适用于伴侣。您可以为配偶和{maxAge}岁以下的子女投保。',
    deductible: '免赔额',
    coverage_level_table_header: '保障级别',
    fbs_plan_auto_enrolled_label: '您可以在下方选择额外的保障项目。',
    fbs_plan_label: '选择您的保险范围。',
    no_plans_info_bar: {
      contentful_name: '[BenefitDetails] No Plans Info Bar',
      header:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '在下方了解有关此福利如何运作的更多信息。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      url_button_text:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
    },
    coverage_level_table_subheader: '您可以在注册时选择您偏好的金额。',
  },
};
